import SearchCustomFields from './SearchCustomFields';

export default SearchCustomFields;
